export default {
  ONE_HOUR: 1,
  TWENTY_FOUR_HOURS: 24,
  FIVE_DAYS: 120,

  HOURS_TO_WORDS: [
    [0, 'Now'],
    [1, 'hour'],
    [24, 'working day'],
    [168, 'week']
  ].reverse(),

  DELIVERY_TYPE_MAPPINGS: new Map([
    ['POST_EXPRESS', 'POST'],
    ['COURIER_EXPRESS', 'COURIER']
  ]),

  deliveryTimeInWords(deliveryTimeInHours) {
    // matches display logic in MyLab from:
    //  https://github.com/livelink/web-kiosk/pull/4978/files#diff-f327d76516e7305172dfe2d302a581a5R31
    //  https://github.com/livelink/web-kiosk/pull/4978/files#diff-b60a7f2b406c190d766fd5ffa56baf9eR57
    // given 24, returns '1 day' instead of '24 hours'
    // given 35, returns '35 hours' instead of '1 day 10 hours'

    let str = '';

    this.HOURS_TO_WORDS.find(mapping => {
      const hours = mapping[0],
        name = mapping[1],
        quotient = Math.floor(deliveryTimeInHours / hours),
        modulus = deliveryTimeInHours % hours;

      if (deliveryTimeInHours === 0 && hours === 0) {
        return (str = name);
      }

      if (quotient > 0 && modulus === 0) {
        // e.g. [3] [week][s]
        str = `${quotient} ${name}${quotient > 1 ? 's' : ''}`;
      }

      return str.length > 0;
    });

    return str;
  },

  productsDeliveryOptionsTiers(productsDeliveryOptions, deliveryOptions) {
    let hasOneHourPickup = false,
      hasSameDayPickup = false,
      hasShipping = false;

    productsDeliveryOptions.forEach((productDeliveryOptionKey) => {
      const option = deliveryOptions.find(option => option.key == productDeliveryOptionKey);

      hasOneHourPickup || (hasOneHourPickup = this.isOneHourPickup(option));
      hasSameDayPickup || (hasSameDayPickup = this.isSameDayPickup(option));
      hasShipping || (hasShipping = this.isShipping(option));
    });

    return {
      hasOneHourPickup,
      hasSameDayPickup,
      hasShipping
    };
  },

  isOneHourPickup(option) {
    if (!option) {
      return false;
    }

    return option.type === 'PICKUP' && option.time_hours <= this.ONE_HOUR;
  },

  isSameDayPickup(option) {
    if (!option) {
      return false;
    }

    return !this.isOneHourPickup(option) &&
      option.type === 'PICKUP' && option.time_hours <= this.TWENTY_FOUR_HOURS;
  },

  isShipping(option) {
    if (!option || !Object.keys(option).length) {
      return false;
    }

    return !this.isOneHourPickup(option) && !this.isSameDayPickup(option);
  },

  deliveryOptionType(option) {
    const rawType = (option || {}).type;
    const mappedType = this.DELIVERY_TYPE_MAPPINGS.get(rawType);

    return mappedType || rawType;
  }
};
